module.exports = __webpack_public_path__ + "img/Sample_Certificate_ITS.bc1643f6.jpg";